// В.2.d-1: Дрон-дефибриллятор (liv_dron_defibrillyator, rare, 1/1/4).
// Приказ при выставлении: «Навешивает на союзного юнита Иммунитет до конца
// следующего хода, но снижает здоровье до 1».
//
// Picker: только СВОИ юниты на поле (≠ сам Дрон). Если своих нет — Приказ
// сгорает (стандартное поведение для Приказов с picker'ом).
//
// Эффект:
//   1. applyImmunity(target, cardId, expiresAtTurn = state.currentTurn + 2).
//      Бафф активен в Ф3 текущего хода и весь следующий ход; снимается в
//      Ф1 хода state.currentTurn+2 (как Адреналин в В.2.c).
//   2. target.current.hp = min(1, target.current.hp). Прямое присвоение,
//      не через damageUnit. max_hp не меняется. Если current_hp уже ≤ 1 —
//      НЕ повышаем (хил тоже не применяется).
//
// Picker реализован через placement-prompts.js: в Ф2 при выставлении Дрона
// открывается prompt 'defibrillyator', в opts сохраняется immuneTargetInstanceId,
// в Ф3 функция dronDefibrillyatorOrder читает его и применяет эффект.

import { applyImmunity } from '../../keywords/immune.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

export const CARD_ID = 'liv_dron_defibrillyator';
const LABEL = 'Дрон-дефибриллятор';

registerImplementedAbility(CARD_ID, 'order');

// Кандидаты для picker'а: свои юниты на поле, кроме самого Дрона.
export function dronDefibrillyatorTargets(state, ownerIdx, dron) {
  const me = state.players?.[ownerIdx];
  if (!me) return [];
  return me.unitsOnField().filter(u =>
    u.type === 'unit' && (!dron || u.instanceId !== dron.instanceId) && u.isAlive()
  );
}

// Поиск юнита по instanceId на поле игрока.
function findOwnUnitByInstanceId(state, ownerIdx, instanceId) {
  if (instanceId == null) return null;
  const me = state.players?.[ownerIdx];
  if (!me) return null;
  for (const u of me.unitsOnField()) {
    if (u.instanceId === instanceId) return u;
  }
  return null;
}

export function dronDefibrillyatorOrder(state, ownerIdx, dron, opts = {}) {
  if (!dron || !dron.isAlive()) return;
  // Молчание блокирует Приказ (стандарт по диздоку 6.7).
  if (dron.current?.silenced) return;
  const candidates = dronDefibrillyatorTargets(state, ownerIdx, dron);
  if (candidates.length === 0) {
    state.log?.add(`📋 ${LABEL}: нет цели — Приказ сгорает`);
    return;
  }
  // Цель из opts (UI игрока) или авто-выбор (бот).
  // ВАЖНО (В.2.d-1-fix1): для игрока НЕТ fallback'а «взять случайного союзника».
  // Если opts.immuneTargetInstanceId === null — игрок явно нажал «Пропустить»,
  // Приказ сгорает (правило проекта: лучше сгореть, чем тихо выбрать не то).
  // Если opts вообще не выставлен — это бот-цепочка (botPlacement не открывает
  // picker), там допустимо выбрать случайно.
  let target = null;
  const optsHasKey = Object.prototype.hasOwnProperty.call(opts, 'immuneTargetInstanceId');
  if (opts.immuneTargetInstanceId != null) {
    target = findOwnUnitByInstanceId(state, ownerIdx, opts.immuneTargetInstanceId);
    // Цель должна быть живым своим юнитом и не самим Дроном.
    if (target && (target === dron || !target.isAlive() || target.type !== 'unit')) {
      target = null;
    }
    if (!target) {
      state.log?.add(`📋 ${LABEL}: цель из выбора недоступна — Приказ сгорает`);
      return;
    }
  } else if (optsHasKey) {
    // Игрок явно пропустил выбор (UI положил {immuneTargetInstanceId: null}).
    state.log?.add(`📋 ${LABEL}: цель не выбрана — Приказ сгорает`);
    return;
  } else {
    // Бот-цепочка: opts пустой, нет ключа — авто-выбор случайного союзника.
    target = candidates[state.rng.int(candidates.length)];
  }
  const expiresAtTurn = state.currentTurn + 2;
  applyImmunity(state, target, CARD_ID, expiresAtTurn);
  // Снижаем current_hp до 1 (но не повышаем, если уже ≤ 1).
  const hpBefore = target.current.hp;
  if (hpBefore > 1) target.current.hp = 1;
  state.log?.add(
    `📋 ${LABEL} → ${target.name_ru} [${state.players[ownerIdx]?.name}]: ` +
    `Иммунитет до начала хода ${expiresAtTurn}, ХП ${hpBefore}→${target.current.hp}`
  );
}
